import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home-container"
}
const _hoisted_2 = { class: "app__title mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Markdown = _resolveComponent("Markdown")!

  return (_ctx.eventData && _ctx.eventData.bookingCancelationPolicy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              class: "app__header__title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("program.events")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("footer.bookingCancellationPolicy")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.eventData && _ctx.eventData.bookingCancelationPolicy)
          ? (_openBlock(), _createBlock(_component_Markdown, {
              key: 0,
              source: _ctx.bookingCancelationPolicy,
              class: "policies gray__base__color"
            }, null, 8, ["source"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}